import { Component, OnInit, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogTitle,
    MatDialogActions,
    MatDialogContent
} from '@angular/material/dialog';
import {HydraService} from '../../../core/services/hydra.service';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ToolsService} from '../../services/tools/tools.service';
import {TranslationService} from '../../services/translation.service';
import {api} from '../../../api/api-dictionnary';
import {DossierRecevableRequest} from '../../../class/api/DossierRecevableRequest';
import {DossierNonRecevableRequest} from '../../../class/api/DossierNonRecevableRequest';
import {Utilisateur} from '../../../interface/api/Utilisateur';
import {ExDossier} from '../../../class/ex/ex-dossier';
import { UpperCasePipe, SlicePipe } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-recevabilite',
    templateUrl: './modal-recevabilite.component.html',
    styleUrls: ['./modal-recevabilite.component.scss'],
    providers: [TranslationService],
    imports: [MatDialogTitle, FormsModule, ReactiveFormsModule, MatSelect, MatOption, MatCheckbox, MatDialogActions, MatButton, UpperCasePipe, SlicePipe, MatDialogContent]
})
export class ModalRecevabililteComponent implements OnInit {
    toolsService = inject(ToolsService);
    private hydraService = inject(HydraService);
    private translationService = inject(TranslationService);
    dialogRef = inject<MatDialogRef<ModalRecevabililteComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);



    public formRecevabilite: FormGroup = new FormGroup({
        statut: new FormControl<number|null>(null, Validators.required),
        dossier: new FormControl<string>('', Validators.required),
        commentaire: new FormControl<string>('')
    });

    public nePasEnvoyerMail = false;

    public dossier: ExDossier | null;
    public candidat: Utilisateur | null;
    public titreDossier = '';



    ngOnInit() {
        this.dossier = this.data.dossier;
        if (!this.dossier) {
            alert('error #6441158745');
            this.dialogRef.close();
            return;
        }

        if(typeof this.dossier.candidat !== 'string'){
            this.candidat = this.dossier.candidat;
        }

        this.formRecevabilite.patchValue(
            {
                dossier: this.dossier['@id']
            }
        );
        this.formRecevabilite.get('statut').valueChanges
            .subscribe(statut => {
                const commentaireFC = this.formRecevabilite.get('commentaire');
                if (statut == 4) {
                    commentaireFC.setValidators([Validators.required]);
                } else {
                    commentaireFC.setValidators(null);
                }
                commentaireFC.updateValueAndValidity();
            });

        this.titreDossier = this.translationService.getTranslation(this.dossier, 'fr')?.titre || '';
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    changerStatut() {
        const formValues = this.formRecevabilite.value;
        if (this.formRecevabilite.get('statut').value == 4) {
            this.setNonRecevable(formValues);
        } else {
            this.setRecevable(formValues);
        }
    }

    private setRecevable(formValues: any) {
        const request = new DossierRecevableRequest();
        request.dossier = formValues.dossier;
        request.complement = '' + formValues.commentaire;

        this.hydraService
            .post(api.dossierRecevable, request)
            .subscribe(() => {
                    this.dossier.setStatut(5);
                    this.dialogRef.close(true);
                }
            );
    }

    private setNonRecevable(formValues: any) {
        const request = new DossierNonRecevableRequest();
        request.dossier = formValues.dossier;
        request.complement = '' + formValues.commentaire;
        request.sendMail = !this.nePasEnvoyerMail;

        this.hydraService
            .post(api.dossierNonRecevable, request)
            .subscribe(() => {
                this.dossier.setStatut(4);
                this.dialogRef.close(true);
            });
    }
}
